'use strict';

var ES2015 = require('./es2015');

var assign = require('./helpers/assign');

var ES2016 = assign(assign({}, ES2015), {
  // https://github.com/tc39/ecma262/pull/60
  SameValueNonNumber: function SameValueNonNumber(x, y) {
    if (typeof x === 'number' || typeof x !== typeof y) {
      throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
    }

    return this.SameValue(x, y);
  }
});
module.exports = ES2016;